import { ColorProvider } from './ContextParts/ColorContext'
import { LibraryProvider } from './ContextParts/LibraryContext'

export const Context = ({ children }) => {
	return (
		<ColorProvider>
			<LibraryProvider>{children}</LibraryProvider>
		</ColorProvider>
	)
}
